export const roleMap: any = {
  superadmin: 'Super Admin',
  support: 'Support',
  admin: 'Admin',
  teacher: 'Teacher',
  student: 'Student',
  qb_author: 'QB Author',
  parent: 'Parent',
  collaborator: 'Collaborator',
  invigilator: 'Invigilator',
};

export const isStaging = import.meta.env.VITE_MODE === 'staging';
export const isDevelopment = import.meta.env.VITE_MODE === 'development';
export const isProduction = import.meta.env.VITE_MODE === 'production';
export const isDemo =
  import.meta.env.VITE_MODE === 'demo' || import.meta.env.VITE_MODE === 'demo-internal';

export const MATH_FONTS_DIRECTORY = '/katex/fonts/';
